import { LocationGroupFragment } from '@occc/graphql';
import { useGetLocationGroupsLazy } from '@occc-app/dataAccessLayer/locationGroup/queries';

import { LocationGroupSelectItem } from './types';

export const mapLocationGroupsQueryResponseToRawArray = (
  response: ReturnType<typeof useGetLocationGroupsLazy>['response'],
): LocationGroupSelectItem[] =>
  response.data ? response.data.map(({ uuid, name }) => ({ uuid, name })) : [];

export const mapRawLocationGroupResponseItemToAutocompleteOption = (
  item: LocationGroupFragment,
) => ({
  value: item.uuid,
  label: item.name,
  _raw: item,
});
